/* ------------------------------------------------------------------
// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
// TODO: 企業向けサイトのみで使いたいメールドメインは引数として渡すなど設計を考慮する
--------------------------------------------------------------------- */
function autoCompleteEmailDomains() {
  /* ------------------------------------------------------------------
   *  Emailサジェストドメインリスト(汎用及びダイナミックな企業用)
  --------------------------------------------------------------------- */
  // NOTE: 企業ごとのメールドメイン候補を持つ要素（_company_email_autocomplete_domains から描画される）。
  //   volunteer-portal.jp のサブドメイン移行で URL から企業名を判別できなくなったため、JSフッククラスで直接取得する。
  const companyList = document.querySelector(".jsCompanyEmailList");
  let domainList = [
    "@gmail.com",
    "@icloud.com",
    "@docomo.ne.jp",
    "@ezweb.ne.jp",
    "@yahoo.co.jp",
    "@i.softbank.jp",
    "@softbank.ne.jp",
    "@hotmail.com",
    "@au.com",
    "@outlook.jp",
    "@yahoo.ne.jp",
  ];
  if (companyList) {
    const storedCompanyDomainList = JSON.parse(companyList.dataset.list); // spread/companies/buyer_company_contacts/会社名/_company_email_autocomplete_domainsからデータを取得
    domainList = domainList.concat(storedCompanyDomainList);
  }
  /* ------------------------------------------------------------------
   * emailフォームが入力された際に使われる変数の定義
  --------------------------------------------------------------------- */
  const supportInput = document.getElementById("jsEmailInput");
  // NOTE: メール入力欄が存在しないページ（sbplayers等）では実行対象外
  if (!supportInput) return;
  let domains = []; // @より前を含めたドメインリストを格納
  let currentVal; // 入力している内容を取得
  let atIndexPosition = 0; // @より前の文字数取得
  let mailname; // @より前の文字列取得
  let autocompleteSetFlag = false; // autocompleteが構築されているかの管理
  let currentFocus = -1; // 現在ハイライトされているサジェスト
  let scroll; // 現在のスクロールの位置、サジェストリスト内スクロール時に使用

  window.addEventListener("scroll", (_event) => {
    scroll = window.pageYOffset || document.documentElement.scrollTop;
  });
  /* ------------------------------------------------------------------
   *  Emailフォームが入力される際のイベント分岐
   *  フォームに@を入力してから一文字以上入力した時のみサジェストを構築及び表示
  --------------------------------------------------------------------- */
  function handleAutocomplete() {
    supportInput.addEventListener("keydown", function (e) {
      supportInput.value = replaceFullToHalf(supportInput.value);
      currentVal = supportInput.value;
      if (
        currentVal.includes("@") &&
        currentVal[currentVal.length] != "@" &&
        e.key !== "@" &&
        e.key !== "Backspace" &&
        e.key !== "Delete"
      ) {
        handleScrollKey(e);
        if (!autocompleteSetFlag) autocompleteSetFlag = true;
        domains = [];
        setAutocompleteList(supportInput); //  サジェストで表示するリストを作成
      } else {
        domains = []; // 構築したautocompleteのリスト破棄
        const suggestions = document.getElementById(
          `${this.id}AutocompleteList`
        );
        if (autocompleteSetFlag) autocompleteSetFlag = false;
        if (suggestions) suggestions.remove();
      }
    });
  }

  // 全角から半角へ変換
  // TODO:
  // アンドロイド/chromeの実機(エミュレーターではなく)で、
  // 日本語キーボード"＠"を押すと表示するべき全てのサジェストが表示されてしまう
  function replaceFullToHalf(str) {
    return str.replace(/[！-～]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );
  }

  /* ------------------------------------------------------------------
   *  サジェストで表示するリストを作成
  --------------------------------------------------------------------- */
  function setAutocompleteList(target) {
    atIndexPosition = currentVal.indexOf("@"); // @より前の文字数と文字列取得
    mailname = currentVal.slice(0, atIndexPosition);
    for (let i = 0; i < domainList.length; i += 1) {
      domains[i] = mailname + domainList[i]; // @より前を含めたドメインリストの作成(例: [test@gmail.com, ...])
    }
    autocomplete(target, domains); // サジェストを表示
  }

  /* ------------------------------------------------------------------
  // サジェストを表示
  --------------------------------------------------------------------- */
  function autocomplete(inp, arr) {
    inp.addEventListener("input", function (_e) {
      if (autocompleteSetFlag) {
        let listContainer;
        let matchingItemContainer;
        let i;
        const val = this.value;
        closeAllLists(); // 既に開かれているサジェストを閉じる
        if (!val) {
          return false;
        }
        currentFocus = -1;
        // サジェストをリストするためのcontainerを作成
        listContainer = document.createElement("DIV");
        listContainer.setAttribute("id", `${this.id}AutocompleteList`);
        listContainer.setAttribute("class", "autocompleteItems");
        this.parentNode.appendChild(listContainer);

        // サジェスリストをDOMに追加
        for (i = 0; i < arr.length; i += 1) {
          // 文字がテキストフィードのものと一致するかをチェック
          if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
            // 一致したものをdivで表示する(boldで表示)
            matchingItemContainer = document.createElement("DIV");
            matchingItemContainer.innerHTML = `<strong>${arr[i].substr(
              0,
              val.length
            )}</strong>`;
            matchingItemContainer.innerHTML += arr[i].substr(val.length);

            // サジェストアイテムの値を見えないインプットに入れ、それを選択後に反映できる様に準備
            matchingItemContainer.innerHTML += `<input type='hidden' value='${arr[i]}'>`;

            // サジェストのアイテムをクリックした時にそれがテキストフィールドに反映されるようにする
            matchingItemContainer.addEventListener("click", function (_e) {
              const clickedValue = this.getElementsByTagName("input")[0].value;
              supportInput.value = clickedValue;
              $("#jsEmailInput").trigger("change"); // JQueryのvalidationを通過させるためにeventを作成
              closeAllLists(); // サジェストをDOMから取り除く
            });
            bodyTag = document.getElementsByTagName("BODY")[0];
            htmlTag = document.getElementsByTagName("html")[0];
            listContainer.appendChild(matchingItemContainer);
          }
        }
      }
    });
  }

  /* ------------------------------------------------------------------
    * 矢印キー↑↓でサジェスト内のアイテムを選択できる
    * 矢印キーで選択されたアイテムにはactiveクラスが付けられる
    * activeクラスまで自動でスクロールされる
    * 選択されたアイテムはハイライトされる
  --------------------------------------------------------------------- */

  function handleScrollKey(e) {
    let container = document.getElementById("jsEmailInputAutocompleteList");
    if (container) container = container.getElementsByTagName("div");
    if (e.key === "ArrowDown") {
      currentFocus += 1; // ↓キーが押された時にフォーカスを一つ下に下げる
      addActive(container); // 現在選択されているサジェストのアイテムフォーカスを当てる
      handleScroll();
    }
    if (e.key === "ArrowUp") {
      currentFocus -= 1; // ↑キーが押された時にフォーカスを一つ上に上げる
      addActive(container); // 現在選択されているサジェストのアイテムフォーカスを当てる
      handleScroll();
    }
    if (e.key === "Enter") {
      e.preventDefault(); // enterが押されてもkeydown中はフォームが送信されないように変更
      if (currentFocus > -1) {
        if (container) container[currentFocus].click(); // クリックでもフォーカスが変更されるようにする
      }
    }
  }

  // 矢印で選択されたアイテムにactiveクラスを付ける
  function addActive(container) {
    if (!container) return false;
    removeActive(container);
    if (currentFocus >= container.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = container.length - 1;
    container[currentFocus].classList.add("autocompleteActive");
    const selectedValue = document.querySelector(
      ".autocompleteActive :nth-child(2)"
    ).value; // テキストフィールドにサジェストの値を自動で入れる
    supportInput.value = selectedValue;
  }

  function removeActive(container) {
    for (let i = 0; i < container.length; i += 1) {
      container[i].classList.remove("autocompleteActive"); // サジェストの全てのアイテムからactiveクラスを取り除く
    }
  }

  // サジェスト内でactiveクラスまでスクロールする
  function handleScroll() {
    // TODO: ブラウザ毎にコードを変えるのは好ましくないため、改善の余地あり
    agent = window.navigator.userAgent.toLowerCase();
    if (agent.indexOf("firefox") > -1) {
      document
        .querySelector(".autocompleteActive")
        .scrollIntoView({ behavior: "smooth" });
      if ("scrollingElement" in document) {
        document.scrollingElement.scrollTo({ top: scroll, behavior: "smooth" });
      } else {
        window.scrollTo({ top: scroll, behavior: "smooth" });
      }
    } else {
      document.querySelector(".autocompleteActive").scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
      window.scrollTo({ top: scroll, behavior: "smooth" });
    }
  }

  /* ------------------------------------------------------------------
    * サジェストをリストから取り除く
  --------------------------------------------------------------------- */
  function closeAllLists(element) {
    const list = document.getElementsByClassName("autocompleteItems");
    for (let i = 0; i < list.length; i += 1) {
      if (element != list[i] && element != supportInput) {
        list[i].parentNode.removeChild(list[i]);
      }
    }
  }
  document.addEventListener("click", (e) => {
    closeAllLists(e.target); // テキストフィールド外をクリックされた時にリストを閉じる
  });

  handleAutocomplete();
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default autoCompleteEmailDomains;
